/**
 * Live-folder delivery glyph: state -> color grammar.
 *
 * Mirrors the matrix-app grammar (field-tested 27-08: a fixed red hue made
 * success and failure indistinguishable), using Tank's own palette values
 * from statusUtils: amber while queued, green once landed, red on failure.
 * Distinct from the red .liveBadge on FTP targets -- that badge marks a
 * target's CONFIG as live; this glyph reports a photo's DELIVERY STATE.
 */
export const LIVE_GLYPH_COLORS = {
  pending: '#ff9b64', // tagging/pending amber
  sent: '#68ff9a', // done green
  failed: '#ff6b6b', // error red
};

/**
 * @param {string|null|undefined} state - export_summary.live tri-state
 * @returns {string|null} color, or null when there is no live lane
 */
export function getLiveGlyphColor(state) {
  return LIVE_GLYPH_COLORS[state] ?? null;
}
